const dropdownTimeItems = [
  { title: 'All Time', value: 'allTime' },
  { title: '30 Days', value: 'last30Days' },
  { title: '7 Days', value: 'last7Days' },
  { title: 'Yesterday', value: 'yesterday' },
  { title: 'Today', value: 'today' },
];

const daysSet = [
  { title: '1', value: '1' },
  { title: '2', value: '2' },
  { title: '3', value: '3' },
  { title: '4', value: '4' },
  { title: '5', value: '5' },
  { title: '6', value: '6' },
  { title: '7', value: '7' },
  { title: '8', value: '8' },
  { title: '9', value: '9' },
  { title: '10', value: '10' },
  { title: '11', value: '11' },
  { title: '12', value: '12' },
  { title: '13', value: '13' },
  { title: '14', value: '14' },
  { title: '15', value: '15' },
  { title: '16', value: '16' },
  { title: '17', value: '17' },
  { title: '18', value: '18' },
  { title: '19', value: '19' },
  { title: '20', value: '20' },
  { title: '21', value: '21' },
  { title: '22', value: '22' },
  { title: '23', value: '23' },
  { title: '24', value: '24' },
  { title: '25', value: '25' },
  { title: '26', value: '26' },
  { title: '27', value: '27' },
  { title: '28', value: '28' },
  { title: '29', value: '29' },
  { title: '30', value: '30' },
  { title: '31', value: '31' },
];

const yearsSet = [
  { title: '2020', value: '2020' },
  { title: '2019', value: '2019' },
  { title: '2018', value: '2018' },
  { title: '2017', value: '2017' },
  { title: '2016', value: '2016' },
  { title: '2015', value: '2015' },
  { title: '2014', value: '2014' },
  { title: '2013', value: '2013' },
  { title: '2012', value: '2012' },
  { title: '2011', value: '2011' },
  { title: '2010', value: '2010' },
  { title: '2009', value: '2009' },
  { title: '2008', value: '2008' },
  { title: '2007', value: '2007' },
  { title: '2006', value: '2006' },
  { title: '2005', value: '2005' },
  { title: '2004', value: '2004' },
  { title: '2003', value: '2003' },
  { title: '2002', value: '2002' },
  { title: '2001', value: '2001' },
  { title: '2000', value: '2000' },
  { title: '1999', value: '1999' },
  { title: '1998', value: '1998' },
  { title: '1997', value: '1997' },
  { title: '1996', value: '1996' },
  { title: '1995', value: '1995' },
  { title: '1994', value: '1994' },
  { title: '1993', value: '1993' },
  { title: '1992', value: '1992' },
  { title: '1991', value: '1991' },
  { title: '1990', value: '1990' },
  { title: '1989', value: '1989' },
  { title: '1988', value: '1988' },
  { title: '1987', value: '1987' },
  { title: '1986', value: '1986' },
  { title: '1985', value: '1985' },
  { title: '1984', value: '1984' },
  { title: '1983', value: '1983' },
  { title: '1982', value: '1982' },
  { title: '1981', value: '1981' },
  { title: '1980', value: '1980' },
  { title: '1979', value: '1979' },
  { title: '1978', value: '1978' },
  { title: '1977', value: '1977' },
  { title: '1976', value: '1976' },
  { title: '1975', value: '1975' },
  { title: '1974', value: '1974' },
  { title: '1973', value: '1973' },
  { title: '1972', value: '1972' },
  { title: '1971', value: '1971' },
  { title: '1970', value: '1970' },
  { title: '1969', value: '1969' },
  { title: '1968', value: '1968' },
  { title: '1967', value: '1967' },
  { title: '1966', value: '1966' },
  { title: '1965', value: '1965' },
  { title: '1964', value: '1964' },
  { title: '1963', value: '1963' },
  { title: '1962', value: '1962' },
  { title: '1961', value: '1961' },
  { title: '1960', value: '1960' },
];

const monthsSet = [
  { title: 'January', value: '0' },
  { title: 'February', value: '1' },
  { title: 'March', value: '2' },
  { title: 'April', value: '3' },
  { title: 'May', value: '4' },
  { title: 'June', value: '5' },
  { title: 'July', value: '6' },
  { title: 'August', value: '7' },
  { title: 'September', value: '8' },
  { title: 'October', value: '9' },
  { title: 'November', value: '10' },
  { title: 'December', value: '11' },
];

const usStates = [
  { title: 'Alabama', value: 'AL' },
  { title: 'Alaska', value: 'AK' },
  { title: 'Arizona', value: 'AZ' },
  { title: 'Arkansas', value: 'AR' },
  { title: 'California', value: 'CA' },
  { title: 'Colorado', value: 'CO' },
  { title: 'Connecticut', value: 'CT' },
  { title: 'Delaware', value: 'DE' },
  { title: 'Florida', value: 'FL' },
  { title: 'Georgia', value: 'GA' },
  { title: 'Guam', value: 'GU' },
  { title: 'Hawaii', value: 'HI' },
  { title: 'Idaho', value: 'ID' },
  { title: 'Illinois', value: 'IL' },
  { title: 'Indiana', value: 'IN' },
  { title: 'Iowa', value: 'IA' },
  { title: 'Kansas', value: 'KS' },
  { title: 'Kentucky', value: 'KY' },
  { title: 'Louisiana', value: 'LA' },
  { title: 'Maine', value: 'ME' },
  { title: 'Marshall Islands', value: 'MH' },
  { title: 'Maryland', value: 'MD' },
  { title: 'Massachusetts', value: 'MA' },
  { title: 'Michigan', value: 'MI' },
  { title: 'Minnesota', value: 'MN' },
  { title: 'Mississippi', value: 'MS' },
  { title: 'Missouri', value: 'MO' },
  { title: 'Montana', value: 'MT' },
  { title: 'Nebraska', value: 'NE' },
  { title: 'Nevada', value: 'NV' },
  { title: 'New Hampshire', value: 'NH' },
  { title: 'New Jersey', value: 'NJ' },
  { title: 'New Mexico', value: 'NM' },
  { title: 'New York', value: 'NY' },
  { title: 'North Carolina', value: 'NC' },
  { title: 'North Dakota', value: 'ND' },
  { title: 'Ohio', value: 'OH' },
  { title: 'Oklahoma', value: 'OK' },
  { title: 'Oregon', value: 'OR' },
  { title: 'Palau', value: 'PW' },
  { title: 'Pennsylvania', value: 'PA' },
  { title: 'Rhode Island', value: 'RI' },
  { title: 'South Carolina', value: 'SC' },
  { title: 'South Dakota', value: 'SD' },
  { title: 'Tennessee', value: 'TN' },
  { title: 'Texas', value: 'TX' },
  { title: 'Utah', value: 'UT' },
  { title: 'Vermont', value: 'VT' },
  { title: 'Virginia', value: 'VA' },
  { title: 'Washington', value: 'WA' },
  { title: 'West Virginia', value: 'WV' },
  { title: 'Wisconsin', value: 'WI' },
  { title: 'Wyoming', value: 'WY' },
];

const timeFilterSet = [
  { title: 'Since Connection', value: 'dataSinceConnection' },
  { title: 'All Time', value: 'lifetimeData' },
];

const mediaLinks = [
  /* {
    id: 'telegram',
    icon: 'telegram',
    name: 'telegram',
    url: '',
  }, */
  {
    id: 'facebook',
    icon: 'facebook',
    name: 'facebook',
    url: '//www.facebook.com/PlayerRushGames/?modal=admin_todo_tour',
  },
  {
    id: 'youtube',
    icon: 'youtube',
    name: 'youtube',
    url: '//www.youtube.com/channel/UC1xzC_ToATl2pLZo7tOaw0Q/',
  },
  {
    id: 'twitter',
    icon: 'twitter',
    name: 'twitter',
    url: '//twitter.com/playerrushgames',
  },
  {
    id: 'medium',
    icon: 'medium',
    name: 'medium',
    url: '//medium.com/@PlayerRush',
  },
  {
    id: 'discord',
    icon: 'discord',
    name: 'discord',
    url: '//discord.gg/zD2q3UB',
  },
];

const oauthOperators = [
  { id: 'twitch', name: 'Twitch' },
  { id: 'google', name: 'Google' },
  { id: 'discord', name: 'Discord' },
];

const bonusBoardHead = [
  { field: 'level', caption: 'Level', width: '23' },
  { field: 'multiplier', caption: 'Bonus multiplier', width: '36' },
  { field: 'balanceRequired', caption: 'Rush Balance Required', width: '' },
];

const sharingProviders = [
  // linkedin: 'linkedin.com/shareArticle?mini=true&url=',
  // vk: 'vk.com/share.php?url=',
  { id: 'facebook', baseUrl: 'facebook.com/sharer/sharer.php?u=' },
  {
    id: 'twitter',
    baseUrl: 'twitter.com/share?url=',
  },
  { id: 'reddit', reddit: 'reddit.com/submit?url=' },
];

export {
  dropdownTimeItems,
  daysSet,
  monthsSet,
  yearsSet,
  usStates,
  mediaLinks,
  oauthOperators,
  timeFilterSet,
  bonusBoardHead,
  sharingProviders,
};
